import { useEffect, useState } from 'react';

import { ChevronLeftIcon, Modal } from 'components';
import { DeploySuccess } from 'components/DeploySuccess';
import { useTabs } from 'hooks';
import { routes } from 'routes/routesConst';
import { classes } from 'utils';

import SelectFunctions from '../../components/SelectFunctions/SelectFunctions';
import { useListSmartContract } from '../../hooks/useListSmartContracts';

import ListNewSmartContract from './ListNewSmartContract';
import NewSmartContract from './NewSmartContract';

export const ListSmartContracts = () => {
  const {
    isConnect,
    isListSmartContract,
    setIsListSmartContract,
    isMergeContractError,
    mergeContractResult,
    isSmartContractAlreadyListed,
  } = useListSmartContract();
  // Need to create this temporary state as the context state isSmartContractAlreadyListed was giving wrong output because of different scenario
  const [isSmartContractExists, setIsSmartContractExist] = useState(false);

  const { address, network } = mergeContractResult?.MergeContract.contract || {};

  const { selectedTab, setSelectedTab, tabs } = useTabs(
    [
      {
        child: (
          <NewSmartContract
            onNext={(index) => {
              handleSelectedTab(index ? index : 1);
            }}
          />
        ),
        label: 'Add new smart contract',
        value: 'addNewSmartContract',
      },
      {
        child: <ListNewSmartContract onNext={() => handleSelectedTab(2)} />,
        label: 'List New Smart Contract',
        value: 'listNewSmartContract',
      },
      {
        child: (
          <SelectFunctions
            handleSelectedTab={handleSelectedTab}
            isSmartContractAlreadyListed={isSmartContractAlreadyListed}
            setIsSmartContractExist={setIsSmartContractExist}
          />
        ),
        label: 'Select Functions',
        value: 'selectFunctions',
      },
      {
        child: (
          <DeploySuccess
            submitTo={`${routes.smartContract}/${address?.replace('0x', '')}/${network}`}
            labels={{
              text: isSmartContractExists
                ? 'You have successfully added the new function(s) into the smart contract!'
                : 'Your newly added Smart Contract is successfully listed!',
              button: 'See Smart Contract',
            }}
            isOpen
            isModal={false}
            isDarkTheme
          />
        ),
        label: 'Success',
        value: 'success',
        disabled: !!isMergeContractError,
      },
    ],
    0
  );
  function handleSelectedTab(tabIndex: number) {
    setSelectedTab(tabIndex);
  }

  useEffect(() => {
    !isListSmartContract && setSelectedTab(0);
  }, [isListSmartContract]);

  if (!isListSmartContract) {
    return <></>;
  }
  return (
    <Modal
      className="p-0 max-w-[560px]"
      setIsOpen={() => setIsListSmartContract()}
      isOpen
      isDarkTheme
      isHidden={isConnect}
      classNames={{
        dialog: 'z-[100]',
        baseWrapper: 'max-w-[unset] m-0 h-full',
        base: 'max-h-[95vh] overflow-auto scrollbar-white',
        close: classes(
          'bg-black sm:top-[25px] sm:right-8 top-[26px] right-[12px]',
          !!selectedTab && 'top-[15px] sm:top-[15px]'
        ),
      }}
    >
      {selectedTab >= 1 && selectedTab < 3 && (
        <div className="px-8 pt-6 pb-4 w-full border border-[#1f1f1f] rounded-t-3xl">
          <button
            className="flex items-center gap-2"
            onClick={() =>
              isSmartContractAlreadyListed ? setSelectedTab(0) : setSelectedTab(selectedTab - 1)
            }
          >
            <ChevronLeftIcon className="h-5 w-5" />
            <div>Back</div>
          </button>
        </div>
      )}
      <div
        className={classes(
          'w-full  flex flex-col flex-1 rounded-3xl border border-solid border-[#1C1C1C] shadow-[0px_4px_10px_0px_#ffffff08]',
          selectedTab === 2 && 'sm:pt-6',
          selectedTab > 0 && 'rounded-none rounded-b-3xl border-t-0 p-8'
        )}
      >
        {tabs[selectedTab].child}
      </div>
    </Modal>
  );
};

export default ListSmartContracts;
